// Notion-style color palette
export const TEXT_COLORS = [
  { key: 'default', label: 'Default', value: '' },
  { key: 'gray', label: 'Gray', value: '#9B9A97' },
  { key: 'brown', label: 'Brown', value: '#64473A' },
  { key: 'orange', label: 'Orange', value: '#D9730D' },
  { key: 'yellow', label: 'Yellow', value: '#DFAB01' },
  { key: 'green', label: 'Green', value: '#0F7B6C' },
  { key: 'blue', label: 'Blue', value: '#0B6E99' },
  { key: 'purple', label: 'Purple', value: '#6940A5' },
  { key: 'pink', label: 'Pink', value: '#AD1A72' },
  { key: 'red', label: 'Red', value: '#E03E3E' },
];

export const BACKGROUND_COLORS = [
  { key: 'default', label: 'Default', value: '' },
  { key: 'gray', label: 'Gray', value: '#F1F1EF' },
  { key: 'brown', label: 'Brown', value: '#F4EEEE' },
  { key: 'orange', label: 'Orange', value: '#FBECDD' },
  { key: 'yellow', label: 'Yellow', value: '#FBF3DB' },
  { key: 'green', label: 'Green', value: '#EDF3EC' },
  { key: 'blue', label: 'Blue', value: '#E7F3F8' },
  { key: 'purple', label: 'Purple', value: '#F6F3F9' },
  { key: 'pink', label: 'Pink', value: '#F9F0F5' },
  { key: 'red', label: 'Red', value: '#FDEBEC' },
];
